import { createErrorReporter } from '@sleepstation/error-reporter'
import { isRunningInBrowser } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const errorReporter = isRunningInBrowser() ? createErrorReporter() : {}

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const getErrorReporter = () => errorReporter

export default getErrorReporter
